module.exports = {
    help: {
        pages: 0,
    }
};



//////////////////
// WEBPACK FOOTER
// ./cfg/help-config.js
// module id = 12
// module chunks = 0